import mixin from "./mixin";
import createPersistedState from "vuex-persistedstate";
import { FusionProject } from "@/types";

const namespace: FusionProject = "wallet";

export const plugins = [
  createPersistedState({
    key: namespace,
    paths: [
      namespace + ".mixin.assets",
      namespace + ".mixin.addedAssets",
      namespace + ".mixin.hidden",
      namespace + ".assets"
    ]
  })
];

export default {
  namespaced: true,
  modules: {
    mixin
  },
  actions: {
    removeWalletData({ dispatch }) {
      dispatch("wallet/mixin/removeAssets", {}, { root: true });
      dispatch("wallet/mixin/snapshots/removeSnapshots", {}, { root: true });
    }
  }
};
